<template>
	<div class="d-lg-flex">
        <div class="filter__title d-none d-lg-flex">
            {{ $translate("Ceres::Template.itemFilter") }}
        </div>
        <div class="item-filter__wrapper d-lg-flex">
            <item-filter v-for="facet in facets"
                         :facet="facet"
                         :key="facet.id"
                         :padding-classes="paddingClasses"
                         :padding-inline-styles="paddingInlineStyles"
                         ref="itemFilter"
                         :desktop-filter="desktopFilter">
            </item-filter>

			<span class="filter__total d-none d-lg-block">
            	{{ filterTotal }} {{ $translate("HoferAntikschmuck::Template.objects") }}
        	</span>
        </div>

		<div class="card-all d-lg-none">
			<button @click="applyFacets()"
					:class="{'filter-btn--disabled': selectedFacets && selectedFacets.length <= 0}">
				{{ $translate("HoferAntikschmuck::Template.applyFilter") }}
				<icon icon="check" :loading="isLoading"></icon>
			</button>
			<span @click="resetAllTags()"
				  :class="{
                    'filter-btn--disabled': !isFacetActive}">
                {{ $translate("Ceres::Template.itemFilterReset") }}
                <icon class="d-none" icon="check" :loading="isLoading"></icon>
            </span>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import ItemFilter from "./ItemFilter.vue";
import { ComponentIdMixin } from "ceres/app/mixins/componentId.mixin";

export default {

	name: "item-filter-list",

	components: {
        ItemFilter
    },

	mixins: [ComponentIdMixin],

	props: {
		desktopFilter: {
			type: Boolean,
			default: false,
		},
		facetData: {
            type: Array,
            default() {
                return [];
            }
        },
		allowedFacetsTypes: {
            type: Array,
            default: () => []
        },
		paddingClasses: {
            type: String,
            default: null
        },
		paddingInlineStyles: {
            type: String,
            default: null
        },
        filterTotal: null
    },

	data()
	{
		return {
			initialSelectedFacets: [],
			initialPriceMin: "",
			initialPriceMax: ""
		};
	},

	computed: {
        ...mapState({
            facets(state) {
                if (!this.allowedFacetsTypes.length)
                {
                    return state.itemList.facets;
                }

                return state.itemList.facets
                    .filter(facet => this.allowedFacetsTypes.includes(facet.id) || this.allowedFacetsTypes.includes(facet.type));
            },
            isLoading: state => state.itemList.isLoading,
            selectedFacets: state => state.itemList.selectedFacets
        }),

        isFacetActive() {
            return (
                (this.initialSelectedFacets && this.initialSelectedFacets.length > 0) ||
                (this.selectedFacets && this.selectedFacets.length > 0)
            )
        }
    },

	created() {
		this.$store.commit("addFacets", this.facetData);
	},

    methods: {

        ...mapMutations([
            "resetAllSelectedFacets"
        ]),

        ...mapActions([
            "selectFacet",
            "loadItemList"
        ]),

        resetAllTags() {
            if(this.initialSelectedFacets && this.initialSelectedFacets.length > 0) {

                this.resetAllSelectedFacets();
                this.removePriceFacet();
                this.resetItemFilter();
                this.loadItemList();

            }else if(this.selectedFacets && this.selectedFacets.length > 0) {

                this.resetItemFilter();
                this.resetAllSelectedFacets();
            }
        },

        resetItemFilter() {
            if(typeof this.$refs.itemFilter !== "undefined") {
                for(let i = 0; i < this.$refs.itemFilter.length; i++) {
                    this.$refs.itemFilter[i].clearFilter();
                }
            }
        },

        applyFacets() {
            if(this.selectedFacets && this.selectedFacets.length > 0) {
                window.localStorage.setItem("openFilterToolbar", true);
                this.loadItemList();
            }
        }
    },
}
</script>
